import * as Cookies from "js-cookie";
import React from 'react';

export const setSessionCookie = (session) => {
  Cookies.remove("sessionROC");
  Cookies.set("sessionROC", session, { expires: 14 });
};

export const getSessionCookie = () => {
  const sessionCookie = Cookies.get("sessionROC");
  if (sessionCookie === undefined) {
    return null;
  } else {
    return JSON.parse(sessionCookie);
  }
};

export const SessionContext = React.createContext(getSessionCookie());

/*** TOKEN ***/

export const setTokenCookie = (token) => {
  Cookies.remove("tokenROC");
  Cookies.set("tokenROC", token, { expires: 14 });
};

export const getTokenCookie = () => {
  const tokenCookie = Cookies.get("tokenROC");
  if (tokenCookie === undefined) {
    return null;
  } else {
    return JSON.parse(tokenCookie);
  }
};

/*** OBJECT ***/

export const setObjectCookie = (dados) => {
  Cookies.remove("object");
  Cookies.set("object", dados, { expires: 14 });
};

export const getObjectCookie = () => {
  const dados = Cookies.get("object");
  if (dados === undefined) {
    return null;
  } else {
    return JSON.parse(dados);
  }
};

/*** GENERIC ***/

export const setObjectCookie_Generic = (name,dados) => {
  Cookies.remove(name);
  Cookies.set(name, dados, { expires: 14 });
};

export const getObjectCookie_Generic = (name) => {
  const dados = Cookies.get(name);
  if (dados === undefined) {
    return null;
  } else {
    return JSON.parse(dados);
  }
};

export const TokenContext = React.createContext(getTokenCookie());

